/* ============================================================
   whatsapp-widget.js
   Simple WhatsApp button. Click goes straight to WhatsApp.

   TO CHANGE THE NUMBER: edit the one line below. Nothing else.

   Format: country code + number, digits only.
   No "+", no spaces, no dashes, no leading zero.
   Example: +91 99861 22422  ->  919945711109
   ============================================================ */

(function () {
  "use strict";

  var WA_NUMBER = "919945711109";

  function addButton() {
    if (document.getElementById("wa-widget")) return;

    var link = document.createElement("a");
    link.id = "wa-widget";
    link.href = "https://wa.me/" + WA_NUMBER;
    link.target = "_blank";
    link.rel = "noopener";
    link.setAttribute("aria-label", "Chat on WhatsApp");
    link.innerHTML =
      '<img id="wa-img" src="' +
      (window.WA_ICON_URL || "whatsapp-icon.svg") +
      '" alt="">';

    document.body.appendChild(link);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", addButton, { once: true });
  } else {
    addButton();
  }
})();